import { OpenIdConnectState } from "@obg/common.verification";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { OPEN_ID_CONNECT_ACTION_TYPE } from "./open-id-connect.action";

const INITIAL_STATE: OpenIdConnectState = {};

export function openIdConnectReducer(state = INITIAL_STATE, action: ActionWithPayload): OpenIdConnectState {
	switch (action.type) {
		case OPEN_ID_CONNECT_ACTION_TYPE.setOpenIdConnectToken: {
			return updateState(state, {
				token: action.payload.token,
			});
		}
		case OPEN_ID_CONNECT_ACTION_TYPE.clearOpenIdConnectToken: {
			return updateState(state, {
				token: undefined,
			});
		}
		case OPEN_ID_CONNECT_ACTION_TYPE.setOpenIdConnectError: {
			return updateState(state, {
				error: action.payload.error,
			});
		}
		default:
			return state;
	}
}
